export default __webpack_public_path__ + "db38f9b46622246b04782fa4aaf1625a.png";